import { TFunction } from 'i18next';
import flowRight from 'lodash/flowRight';

import {
  withHomeScreenRetentionLayout,
  withMainSimpleLayout,
  withOnboardingLayout,
  withPromoModalLayout,
  withSettingsNavigationLayout,
  withSubModalsLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  BillingPath,
  PersonalInformationPath,
  SecurityPath,
  SubscriptionPath,
} from '~/modules/settings/constants';
import { SETTINGS_PROJECT_CONFIG } from '~/modules/settings/projects';

const PersonalInformation = lazyComponentLoader(
  () => import('./views/PersonalInformation'),
);

const Security = lazyComponentLoader(() => import('./views/Security'));

const Subscription = lazyComponentLoader(() => import('./views/Subscription'));

const Billing = lazyComponentLoader(() => import('./views/Billing'));

export const PersonalInformationRoute = {
  getTitle: (t: TFunction): string =>
    SETTINGS_PROJECT_CONFIG.getPersonalInformationTitle(t),
  path: PersonalInformationPath,
  Component: flowRight(
    withPromoModalLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withHomeScreenRetentionLayout,
    withMainSimpleLayout,
    withSettingsNavigationLayout,
  )(PersonalInformation),
};

export const SecurityRoute = {
  getTitle: (t: TFunction): string =>
    SETTINGS_PROJECT_CONFIG.getSecurityTitle(t),
  path: SecurityPath,
  Component: flowRight(
    withPromoModalLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withHomeScreenRetentionLayout,
    withMainSimpleLayout,
    withSettingsNavigationLayout,
  )(Security),
};

export const SubscriptionRoute = {
  getTitle: (t: TFunction): string =>
    SETTINGS_PROJECT_CONFIG.getSubscriptionTitle(t),
  path: SubscriptionPath,
  Component: flowRight(
    withPromoModalLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withHomeScreenRetentionLayout,
    withMainSimpleLayout,
    withSettingsNavigationLayout,
  )(Subscription),
};

export const BillingRoute = {
  getTitle: (t: TFunction): string =>
    SETTINGS_PROJECT_CONFIG.getBillingTitle(t),
  path: BillingPath,
  Component: flowRight(
    withPromoModalLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withHomeScreenRetentionLayout,
    withMainSimpleLayout,
    withSettingsNavigationLayout,
  )(Billing),
};
